import "../../scss/DetailView.scss";
import "../../scss/Common.scss";
import ReactMarkdown from "react-markdown";

export default function VideoView({
  content,
  youtubeUrl,
}: {
  content: string;
  youtubeUrl?: string;
}) {
  // Helper to extract YouTube video ID from a URL (supports shorts, watch, embed, youtu.be, v/)
  const getYoutubeId = (url: string) => {
    const regExp =
      /(?:youtube\.com\/(?:.*v=|v\/|embed\/|shorts\/)|youtu\.be\/)([\w-]{11})/;
    const match = url.match(regExp);
    return match ? match[1] : null;
  };
  const videoId = youtubeUrl ? getYoutubeId(youtubeUrl) : null;

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          margin: "2rem 0",
        }}
      >
        <iframe
          width="560"
          height="315"
          src={`https://www.youtube.com/embed/${videoId}`}
          title="YouTube video player"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
          style={{ maxWidth: "100%", borderRadius: "12px" }}
        />
      </div>

      <ReactMarkdown
        components={{
          img: ({ node, ...props }) => (
            <img
              style={{
                display: "block",
                margin: "0 auto",
                maxWidth: "80%",
                height: "auto",
                borderRadius: "8px",
              }}
              {...props}
            />
          ),
        }}
        className="prose max-w-none"
      >
        {content}
      </ReactMarkdown>
    </div>
  );
}
